import { render, staticRenderFns } from "./KpiTop.vue?vue&type=template&id=281de968"
import script from "./KpiTop.vue?vue&type=script&lang=js"
export * from "./KpiTop.vue?vue&type=script&lang=js"
import style0 from "./KpiTop.vue?vue&type=style&index=0&id=281de968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports